import React, { useState, useEffect } from "react";
import {
    Modal,
    Card,
    Typography,
    Image,
    Input,
    Select,
    Button,
    Row,
    Col,
    Checkbox,
} from "antd";
import {
    BarcodeOutlined,
    CarOutlined,
    PoundCircleOutlined,
    AppstoreOutlined,
    ShoppingOutlined,
    UserOutlined,
    ClockCircleOutlined
} from "@ant-design/icons";
import SelectStatusCustom from "../../../components/SelectStatusCustom";
import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import GalleryComponent from "../../../components/GalleryComponent";

const { Title, Text } = Typography;

const ItemDetailModal = ({ visible, onClose, onSave, item, providers }) => {
    const [tracking, setTracking] = useState("");
    const [provider, setProvider] = useState("");
    const [status, setStatus] = useState(item?.status || "waiting");
    const handleOnSave = (data) => {
        // Nếu chỉ có `tracking` hoặc chỉ có `provider` được nhập, hiển thị cảnh báo
        if ((!tracking && provider) || (tracking && !provider)) {
            Modal.warning({
                title: "Cảnh báo",
                content: "Vui lòng nhập đủ cả 2 thông tin tracking và provider",
            });
            return;
        }

        // Nếu cả hai đều không nhập hoặc cả hai đều được nhập, cho phép lưu
        if (onSave) {
            onClose();
            onSave(data);
        }
    }

    useEffect(() => {
        setTracking(item?.tracking_number || "");
        setProvider(item?.provider || "");
        setStatus(item?.status || "waiting");
    }, [item, providers]);


    return (
        <Modal
            title={`Item Detail - Order #${item?.order_id || "N/A"}`}
            open={visible}
            onCancel={onClose}
            width={'80%'}
            bodyStyle={{ backgroundColor: "#f5f5f5", padding: 16 }}
            className="custom-modal"
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button
                    key="save"
                    type="primary"
                    onClick={() =>
                        handleOnSave(
                            {
                                ...item,
                                tracking_number: tracking,
                                provider,
                                status,
                            }
                        )
                    }
                >
                    Save
                </Button>,
            ]}
        >
            <Row gutter={16}>
                {/* CỘT TRÁI - Product Info (70%) */}
                <Col span={16}>
                    <Card size="small" style={{ borderRadius: 8, marginBottom: 16, paddingBottom: 16 }}>
                        <div style={{ display: "flex", alignItems: "flex-start" }}>
                            {
                                item?.images && item?.images.length > 0 ?
                                    <div style={{ width: 280, marginRight: 0 }}>
                                        <GalleryComponent
                                            images={item?.images?.map(img => ({
                                                original: img?.origin_url,
                                                thumbnail: img?.thumb_url
                                            })) || []}
                                            showPlayButton={false}
                                            showFullscreenButton={true}
                                        />
                                    </div> :
                                    <Image
                                        src={item?.sku_image}
                                        alt={item?.product_name}
                                        width={180}
                                        style={{
                                            marginRight: 16,
                                            borderRadius: 4,
                                            border: "1px solid #eee",
                                        }}
                                    />
                            }



                            <div style={{ flex: 1, paddingLeft: 20 }}>
                                {/* Tiêu đề sản phẩm */}
                                <Title level={5} style={{ marginBottom: 12 }}>
                                    {item?.product_name}
                                </Title>

                                {/* Đường kẻ phân cách */}
                                <div
                                    style={{
                                        borderTop: "1px solid #f0f0f0",
                                        margin: "12px 0",
                                    }}
                                />

                                {/* Thông tin chi tiết */}
                                <div style={{ lineHeight: "28px" }}>
                                    <p>
                                        <PoundCircleOutlined style={{ marginRight: 6, color: "#52c41a" }} />
                                        Original price: <Text strong>£{item?.original_price || "0"}</Text>
                                    </p>
                                    <p>
                                        <ShoppingOutlined style={{ marginRight: 6, color: "#ff0000" }} />
                                        Platform discount: <Text strong>{item?.platform_discount || "0"}%</Text>
                                    </p>
                                    <p>
                                        <ShoppingOutlined style={{ marginRight: 6, color: "#ff0000" }} />
                                        Seller discount: <Text strong>{item?.seller_discount || "0"}%</Text>
                                    </p>
                                    <p>
                                        <PoundCircleOutlined style={{ marginRight: 6, color: "#52c41a" }} />
                                        Sale price: <Text strong>£{item?.sale_price || "0"}</Text>
                                    </p>
                                    <p>
                                        <AppstoreOutlined style={{ marginRight: 6, color: "#fa8c16" }} />
                                        Variant: <Text strong>{item?.sku_name || "N/A"}</Text>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Card Last Update */}
                    <Card size="small" style={{ borderRadius: 8 }}>
                        <Title level={5} style={{ marginBottom: 12 }}>
                            Last Update
                        </Title>
                        <p>
                            <UserOutlined style={{ marginRight: 6 }} />{" "}
                            {item?.updatedBy_fullname || "N/A"}
                        </p>
                        <p>
                            <ClockCircleOutlined style={{ marginRight: 6 }} />{" "}
                            {item?.updatedAt || "N/A"}
                        </p>
                    </Card>
                </Col>

                {/* CỘT PHẢI - Status & Shipping (30%) */}
                <Col span={8}>
                    {/* Card Status */}
                    <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
                        <Title level={5}>Status</Title>
                        <SelectStatusCustom
                            status={status}
                            onChange={setStatus}
                        />
                    </Card>

                    {/* Card Shipping */}
                    <Card size="small" style={{ borderRadius: 8 }}>
                        <Title level={5}>Item Shipping Information</Title>
                        <div style={{ marginBottom: 16 }}>
                            <Text strong>
                                <BarcodeOutlined /> Tracking Number:
                            </Text>
                            <Input
                                placeholder="Enter tracking number"
                                value={tracking}
                                onChange={(e) => setTracking(e.target.value)}
                                style={{ marginTop: 8 }}
                            />
                        </div>
                        <div>
                            <Text strong>
                                <CarOutlined /> Provider:
                            </Text>
                            <Select
                                placeholder="Select provider"
                                value={provider}
                                onChange={setProvider}
                                style={{ width: "100%", marginTop: 8 }}
                                showSearch
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {providers && providers.length > 0 ? (
                                    providers.map((prov) => (
                                        <Select.Option key={prov?.provider_id} value={prov?.provider_id}>
                                            {prov?.name}
                                        </Select.Option>
                                    ))
                                ) : (
                                    <Select.Option value="" disabled>
                                        No providers available
                                    </Select.Option>
                                )}
                            </Select>
                        </div>
                        {
                            item?.isUpdatedTiktok === 1 ?
                                <Checkbox
                                    checked
                                    style={{ color: '#1890ff', marginTop: 12 }}
                                >
                                    Đã gửi tracking number cho tiktok shop
                                </Checkbox> : null

                        }
                    </Card>
                </Col>
            </Row>
        </Modal>
    );
};

export default ItemDetailModal;
